import _defineProperty from "/workdir/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import Container from "@scentregroup/ui/components/container";
import Heading from "@scentregroup/ui/components/heading";
import classNames from 'classnames';
import ShowMoreV2 from '../show-more-v2';
import { SEE_MORE_TEXT } from '../../constants';
import style from './index.module.scss';
import Card from './card';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const CardList = ({
  heading = '',
  cards,
  className,
  minItems = 0,
  buttonText = SEE_MORE_TEXT
}) => /*#__PURE__*/_jsxs(Container, {
  type: "large",
  className: classNames(style.CardList, className),
  children: [heading && /*#__PURE__*/_jsx(Heading, {
    type: "large",
    children: heading
  }), /*#__PURE__*/_jsx("div", {
    className: style.cardListItems,
    children: /*#__PURE__*/_jsx(ShowMoreV2, {
      minItems: minItems,
      buttonText: buttonText,
      children: cards.map(card => /*#__PURE__*/_jsx(Card, _objectSpread({
        className: style.cardListItem
      }, card), card.title))
    })
  })]
});

export default CardList;